import { useCallback } from "react";
import { useAppDispatch } from "../ducksHook";
import { settingsActions } from "../slices/settings.slice";

type ServiceOperators = {
  onChangeSettings: (params: boolean) => void;
  onChangeProfile: (params: boolean) => void;
  onDeactivatingRequest: () => void;
};

export const useSettingsService = (): Readonly<ServiceOperators> => {
  const dispatch = useAppDispatch();

  return {
    onChangeSettings: useCallback(
      (params: boolean) =>  dispatch(settingsActions.hasSettingsOpen(params)),
      [dispatch]
    ),
    onChangeProfile: useCallback(
      (params: boolean) =>  dispatch(settingsActions.hasProfileOpen(params)),
      [dispatch]
    ),
    onDeactivatingRequest: useCallback(
      () =>  dispatch(settingsActions.deactivateAccount()),
      [dispatch]
    ),
  };
};

export default useSettingsService;
